import { IDelegation, IDelegationData } from "@/entities";

export class Delegation implements IDelegation {
  readonly id?: number;
  readonly oidSol?: string;
  readonly codeSol?: string;
  readonly idSmartcash?: string;
  readonly uniqueCode?: string;
  readonly description?: string;
  readonly zone?: string;
  readonly timeZoneNumber?: number;
  readonly nif?: string;
  readonly descriptionNameDirection?: string;
  readonly principalBol?: boolean;
  readonly externalCode?: string;
  readonly active?: boolean;

  constructor(data: IDelegationData) {
    this.id = data.id;
    this.oidSol = data.oidSol;
    this.codeSol = data.codeSol;
    this.idSmartcash = data.idSmartcash;
    this.uniqueCode = data.uniqueCode;
    this.description = data.description;
    this.zone = data.zone;
    this.timeZoneNumber = data.timeZoneNumber;
    this.nif = data.nif;
    this.descriptionNameDirection = data.descriptionNameDirection;
    this.principalBol = data.principalBol;
    this.externalCode = data.externalCode;
    this.active = data.active;
  }
}
